"use client";
import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import Link from "next/link";
import Title from "../Title";
import HtmlParser from "react-html-parser";
export default function Desc({ data }) {
  return (
    <StyledComponent className="desc pt-200 pb-200">
      <Container>
        <Row>
          <Col lg={7}>
            <Title text={"HR Philosophy"} version number={"I "} />
          </Col>

          <Col lg={{ span: 10, offset: 1 }}>
            <h3>{HtmlParser(data?.title)}</h3>
            <p>{HtmlParser(data?.desc)}</p>
          </Col>
        </Row>
      </Container>
    </StyledComponent>
  );
}
const StyledComponent = styled.section`

  .title {
    p{
      margin-right: 10px;
    }
    h2 {
      padding: 0 !important;
      margin: 0;

      &:after , &:before{
        display: none !important;
      }
    }
  }
  
  h3 {
    margin-top: 60px;
    margin-bottom: 50px;
    font-size: 32px;
    line-height: 36px;
  }
`;
